<!-- favor.wxml -->
<template>
    <div class="favor-box">
        <div class="divider-line"></div>
        <!-- favor -->
        <div class="favor-list-box">
            <nut-infiniteloading
                @loadmore="loadMoreVert"
                :is-show-mod="true"
                :has-more="isHasMore"
                :is-loading="isLoading"
                :threshold="200"
            >
                <div class="favor-list" v-if="favorList.length">
                    <div class="favor-item" v-for="(item,index) in favorList" :key="index">
                        <input type="checkbox" :id="'favor' + item.id" :value="item.id" v-model="goods_ids"/>
                        <label :for="'favor' + item.id">
                            <span :class="['iconfont',goods_ids.indexOf(item.id) != -1 ? 'icon-dui' : '']"></span>
                        </label>
                        <div class="goods-dateil clearfix" @click="toGoods(item.goods_id)">
                            <div class="image-box">
                                <img v-lazy="item.goods.goods_image" class="skeleton-rect" style="max-width: 80%"/>
                            </div>
                            <div class="content-box">
                                <div class="title text-flow skeleton-rect">{{item.goods.goods_name}}</div>
                                <div class="price-box skeleton-rect">
                                    <div class="price">${{item.goods.goods_sku.goods_price}}</div>
                                    <div class="mark-price" v-if="item.goods.goods_sku.line_price > 0 ">
                                        ${{item.goods.goods_sku.line_price}}
                                    </div>
                                </div>
                                <div class="volume-box skeleton-rect">
                                    <div class="volume">销量：{{item.goods.goods_sales}}</div> &nbsp;
                                    <div class="stock"> &nbsp;&nbsp;库存：{{item.goods.goods_sku.stock_num}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nut-infiniteloading>
            <!-- no-result -->
            <div class="noresult" v-if="!favorList.length">
                <div class="cot">
                    <div class="img">
                        <img src="../../assets/images/no_result.png">
                    </div>
                    <p class="text" style="color: #aaa">空空如也</p>
                    <router-link class="browse-btn" to="/">点击逛逛</router-link>
                </div>
            </div>
            <!-- no-result end -->
            <div class="favor-set-box">
                <div class="all-select" @click="allSelect">
                    <span :class="['iconfont',isAllSelect ? 'icon-dui' : '']"></span>
                    全选
                </div>
                <button class="submit-add" @click="deletFavor">删除商品</button>
            </div>

        </div>
        <!-- favor end -->
        <nut-drag direction="y" :style="{right:'0px',bottom:'150px'}">
            <nut-fixednav active-text="收起导航" un-active-text="快速导航" :nav-list="NAVLIST" @selected="selectedNav"></nut-fixednav>
        </nut-drag>
    </div>
</template>
<script>
import Tabber from '@/components/Tabber.vue'

export default {
    name: 'MemberFavor',
    components: {
        Tabber
    },
    data() { //默认数据
        return {
            user_id: 1,
            isAllSelect: false, //是否全选
            noresult: false,
            isHasMore: true,
            isLoading: false,
            goods_ids: [], //删除商品ids
            favorList: [], // 列表
            current_page: 1,
            last_page: 1,
        }
    },
    created() { //视图加载前执行
        let _this = this;
        this.loading = this.$toast.loading('正在加载', {
            coverColor: "rgba(0,0,0,0.5)",
        });
    },
    mounted() { //视图加载完成执行
        let _this = this;
        _this.getFavorList();

    },
    methods: {

        // 获取收藏列表
        getFavorList(page = 1) {
            let _this = this;
            _this._get('user.index/collect', {page}, res => {
                _this.favorList = _this.favorList.concat(res.data.list.data)
                _this.current_page = res.data.list.current_page
                _this.last_page = res.data.list.last_page
                _this.isHasMore = res.data.list.data ? true : false
                _this.loading.hide();
                _this.isLoading = false;
            })
        },

        /**
         *  触底加载
         */
        loadMoreVert() {
            if (this.current_page >= this.last_page) {
                this.isLoading = false;
                this.isHasMore = false;
                return false;
            }
            this.isLoading = true;
            this.isHasMore = true;
            this.getFavorList(this.current_page + 1);
        },

        /**
         * 删除收藏
         */
        deletFavor: function (e) {
            let _this = this;
            if (_this.goods_ids.length == 0) {
                _this.$toast.warn('您还没有收藏商品！');
                return false;
            }
            this.loading = this.$toast.loading('正在删除', {
                coverColor: "rgba(0,0,0,0.5)",
            });
            _this._get('user.index/delCollect', {
                'ids': _this.goods_ids.join(",")
            }, (res) => {
                _this.loading.hide();
                _this.getFavorList();
                _this.$toast.success('删除成功');
            });
        },

        // 去商品详情
        toGoods(goods_id) {
            let _this = this;
            _this.navigationTo('/goods/show', {goods_id: goods_id});
        },

        /**
         *  全选
         */
        allSelect: function () {
            let _this = this;
            if (_this.isAllSelect) {
                _this.isAllSelect = false;
                _this.goods_ids = [];
            } else {
                if (_this.favorList.length == 0) {
                    _this.$toast.warn('您还没有收藏商品！');
                    return false;
                }
                _this.favorList.forEach(function (item, index) {
                    _this.goods_ids.push(item.id);
                });
                _this.isAllSelect = true
            }
        }
    },
    destroyed() {
        let _this = this;
        //切记页面销毁需要销毁
    }
}
</script>
<style lang="scss">
@import "collect";
</style>
